import React from 'react'
import { sharedData } from '../../../models/shared_data'
import { AddressSelect } from './address_select.component';
import { AddressAutocomplete } from './address_autocomplete.component'
import { SelectComponent } from '../../shared/select/select.component'


export class AddressInput extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      addressSelectedId: null,
      selectAllowed: true,
      header: 'Адрес доставки',
      addr_constraints: {}
    }

    if(props.order) {
      this.state.addr_constraints = props.order.address
    }

    if(props.selectNotAllowed) {
      this.state.selectAllowed = false
    }

    if(props.header != null) {
      this.state.header = props.header
    }

    this.selectAddress = this.selectAddress.bind(this)
    this.fieldSelected = this.fieldSelected.bind(this)
    this.districtChanged = this.districtChanged.bind(this)
  }

  updateField(name, e) {
    e.preventDefault()
    this.actualChangeField(name, e.target.value)
  }

  actualChangeField(name, value) {
    const p = this.props.address

    const prms = {
      city: p.city,
      street: p.street,
      dom: p.dom,
      kv: p.kv,
      korp: p.korp
    }

    prms[name] = value
    this.props.onChange(prms)
  }

  isError(name) {
    let v = this.props.address[name]
    if(this.props.error && (!v || v == ''))
      return ' error '
    return ''
  }


  selectAddress(addr) {
    this.props.onChange(addr)
  }

  fieldSelected(h) {
    this.setState(
      {
        addr_constraints: h.address
      }
    )

    let new_h = {}

    Object.keys(this.props.address).forEach((k)=> {
      new_h[k] = this.props.address[k]
    })

    Object.keys(h.address).forEach((k)=> {
      new_h[k] = h.address[k]
    })
    // console.log(new_h)

    this.props.onChange(new_h)
  }

  districtChanged(e) {
    if(this.props.onDistrictChange)
      this.props.onDistrictChange(e)
  }

  render() {
    const prms = this.props.params
    const addr = this.props.address
    const cl = sharedData.data.client
    const ord = this.props.order
    return (
      <div>
        { this.state.header != '' &&
          <div className="h4">
            { this.state.header }
          </div>
        }


        { this.state.selectAllowed && cl && cl.addresses.length > 0 &&
          <AddressSelect onChange={this.selectAddress} selectedId={this.state.addressSelectedId}/>
        }

        <AddressAutocomplete modelName="city" val={this.props.address.city} title="Город" onChange={this.fieldSelected} type="city" constraints={this.state.addr_constraints} />


        { prms && prms.delivery_schedule_system == 'smart' && prms.district_list.length > 1 &&
          <SelectComponent
            opts={prms.district_list}
            value={ord.district_id}
            onChange={ (e)=> { this.districtChanged(e) } }
          />
        }

        <AddressAutocomplete modelName="street" val={this.props.address.street} title="Улица" onChange={this.fieldSelected} type="street" error={this.isError('street') == '' ? false : true} constraints={this.state.addr_constraints}/>


        <div className="row">
          <div className="col-4">

            <div className="input">
              <input className={ "input-white__text" + this.isError('dom') } placeholder="Дом" type="text" value={this.props.address.dom} onChange={(e)=>this.updateField('dom',e)}/>
            </div>
          </div>
          <div className="col-4">
            <div className="input">
              <input className="input-white__text" placeholder="Корпус" type="text" value={this.props.address.korp} onChange={(e)=>this.updateField('korp',e)}/>
            </div>
          </div>
          <div className="col-4">
            <div className="input">
              <input className="input-white__text" placeholder="Кв/офис" type="text" value={this.props.address.kv} onChange={(e)=>this.updateField('kv',e)}/>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/website_default/js/react/cart/make_order/address_input.component.jsx